import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LicenseService } from '../../../../services/license/license.service';
import { ClientService } from '../../../../services/clients/client.service';
import { BaseComponent } from '../../../base.component';

@Component({
  selector: 'app-edit-addon-catalog',
  templateUrl: './edit-addon-catalog.component.html',
  styleUrls: ['./edit-addon-catalog.component.css']
})
export class EditAddonCatalogComponent extends BaseComponent implements OnInit {
  customer_id;
  updateForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  bundle_id: string;
  selectedCompany: string;
  companyName = '';
  addonObj: any;

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    private LS: LicenseService
  ) {
    super();
  }

  ngOnInit() {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) {
      this.getCompany();
    }
    this.updateForm = this.formBuilder.group({
      bundle_name: [{ value: '', disabled: true }],
      monthly_price: ['', [Validators.required, Validators.min(0)]],
      yearly_price: ['', [Validators.required, Validators.min(0)]],
      credits_per_dollar: [200, [Validators.required, Validators.min(0)]],
      addon_sort: [''],
      is_addon_sellable: [true],
      allow_basic: [false],
      allow_professional: [false],
      selectedCompany: [this.customer_id == 0 ? '' : this.customer_id, Validators.required]
    });
    if (localStorage.getItem('edit_addon_catalog_id')) {
      this.bundle_id = localStorage.getItem('edit_addon_catalog_id');
      this.selectedCompany = localStorage.getItem('edit_addon_catalog_company_id');
      this.ngxSpinnerService.show();
      this.LS.getAddonCatalogById(this.selectedCompany, this.bundle_id).subscribe(response => {
        this.ngxSpinnerService.hide();
        if (response.status) {
          this.addonObj = response.data;
          this.dataBinding();
        } else {
          this.toastrService.error(response.message || 'Add-on not found');
          this.router.navigateByUrl('/corporate/addon-catalog-list');
        }
      }, error => {
        this.ngxSpinnerService.hide();
      });
    } else {
      this.router.navigateByUrl('/corporate/addon-catalog-list');
    }
  }

  dataBinding() {
    this.updateForm = this.formBuilder.group({
      bundle_name: [{ value: this.addonObj.bundle_name, disabled: true }],
      monthly_price: [this.addonObj.monthly_price, [Validators.required, Validators.min(0)]],
      yearly_price: [this.addonObj.yearly_price, [Validators.required, Validators.min(0)]],
      credits_per_dollar: [this.addonObj.credits_per_dollar, [Validators.required, Validators.min(0)]],
      addon_sort: [this.addonObj.addon_sort],
      is_addon_sellable: [!!this.addonObj.is_addon_sellable],
      allow_basic: [!!this.addonObj.allow_basic],
      allow_professional: [!!this.addonObj.allow_professional],
      selectedCompany: [this.selectedCompany, Validators.required]
    });
  }

  getCompany() {
    this.clientService.getBUCompanies().subscribe(data => {
      this.getCompanyobj = data.data;
      this.hydrateWorkingCompany(this);
      const row = (this.getCompanyobj || []).find((item: any) => String(item.customer_id) === String(this.selectedCompany));
      this.companyName = row ? row.customer_company_name : '';
    }, error => {
    });
  }

  get f() {
    return this.updateForm.controls;
  }

  goCancel() {
    localStorage.removeItem('edit_addon_catalog_id');
    localStorage.removeItem('edit_addon_catalog_company_id');
    this.router.navigateByUrl('/corporate/addon-catalog-list');
  }

  updateAddonData() {
    this.submitted = true;
    if (this.updateForm.invalid) {
      return;
    }
    const raw = this.updateForm.getRawValue();
    if (raw.is_addon_sellable && !raw.allow_basic && !raw.allow_professional) {
      this.toastrService.error('Select Basic, Professional, or both for a sellable add-on.');
      return;
    }
    const body = {
      company: this.selectedCompany || raw.selectedCompany,
      bundle_id: this.bundle_id,
      monthly_price: raw.monthly_price,
      yearly_price: raw.yearly_price,
      credits_per_dollar: raw.credits_per_dollar,
      addon_sort: raw.addon_sort,
      is_addon_sellable: raw.is_addon_sellable,
      allow_basic: raw.allow_basic,
      allow_professional: raw.allow_professional
    };
    this.ngxSpinnerService.show();
    this.LS.updateAddonCatalog(body).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('Add-on catalog updated successfully');
        this.goCancel();
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
